import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, SortEvent } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SubdepartmentService } from './subdepartment.service';
import Swal from 'sweetalert2';
import { Utilityservice } from '../../utility/utilityservice.service';
import { SubdepartmentmodalComponent } from '../../directives/subdepartmentmodal/subdepartmentmodal.component';
import { GlobalMessage, SubDepartment } from '../../utility/modals';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
import { NgxSpinnerService } from 'ngx-spinner';



@Component({
  selector: 'app-subdepartment',
  templateUrl: './subdepartment.component.html',
  styleUrls: ['./subdepartment.component.css']
})
export class SubdepartmentComponent implements OnInit {
  @ViewChild('dt') dt: any;
  tableData: any[] = [];
  selectedItem: MenuItem | null = null;
  commonScrollHeight = '';
  searchText: string;
  ref: DynamicDialogRef | undefined;
  first2: number = 0;
  rows2: number = 10;
  totalRecords: number = 0;
  options = [];
  paginatorArray = []
  visible: boolean = false;
  excel_paragraph = "";
  templatedownloadtext = '';
  rowsize: number = 10;
  tablecount: number = 0;
  exceldownloadModal = false;
  currentPageIndex: number = 0;
  subdepartmentlistarray: Array<SubDepartment> = [];
  downloadformate = false;
  position = 'top';
  public sortfield = 'departmentname';
  cols = [];
  message: GlobalMessage = new GlobalMessage()
  _selectedColumns = [];
  constructor(public router: Router,private spinner:NgxSpinnerService, public dialogService: DialogService, public PagehelpmodalService: PagehelpmodalService,
    private subdepartmentservice: SubdepartmentService, public utilityservice: Utilityservice) {
    this.excel_paragraph = this.message.downloadexcel_text;
    this.templatedownloadtext = this.message.excelformate_text
  }


  ngOnInit() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight()
    this.getConfiguration();
    this.getsubdepartmentList();
    this.dynamiccols();
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
  }
  dynamiccols() {
    this.cols = [
      { field: "subdepartmentid", header: this.subdeptLabelName+" Id", type: 'Number', sort: true, filter: true, width: '20px', isChecked: true, class: 'headerid' },
      { field: "departmentname", header: "Department Name", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "subdepartmentname", header: this.subdeptLabelName+" Name", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "createdby", header: "Created By", type: 'Date', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "createdon", header: "Created On", type: 'Date', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' }
    ]
    this._selectedColumns = this.cols;
  }

  getsubdepartmentList() {
    //this.spinner.show();
    const currentPageSize = this.rowsize;

    this.subdepartmentservice.getall_subdepartment().subscribe({
      next: (data: any) => {
        //this.spinner.hide();
        this.tableData = data;
        this.subdepartmentlistarray = data.map((item: any) => ({ ...item, isSelect: false }));

        this.options = this.utilityservice.getOptionDropdown(data.length);
        this.paginatorArray = this.options.map((e) => e.value);

        if (!this.paginatorArray.includes(currentPageSize)) {
          this.paginatorArray.push(currentPageSize);
          this.paginatorArray.sort((a, b) => a - b);
        }

        this.rowsize = currentPageSize;
        this.totalRecords = this.subdepartmentlistarray.length;
        this.tablecount = data.count ?? data.length;

        setTimeout(() => {
          if (this.dt) {
            this.dt.first = this.currentPageIndex;
          }
        }, 0);
      },
      error: (error) => {
        //this.spinner.hide();
        const timestamp = new Date().toLocaleString();
        Swal.fire({
          title: error.error?.error || "Error",
          text: `This error occurred at: ${timestamp}`,
          icon: "error",
        });
      },
    });
  }

  subdeptLabelName = "";
  isSupportAdmin = "N";

  getConfiguration(): void {
    this.subdepartmentservice.getConfiguration().subscribe(
      (response) => {
        if (response && response.length > 0) {
          this.subdeptLabelName = response[0]?.subdeptLabelName || 'Sub Department Name';
          this.isSupportAdmin = response[0]?.isSupportAdmin || 'N';

          this.dynamiccols();
        }
      },
      (error) => {
        console.error('Error fetching configuration:', error);
        this.subdeptLabelName = 'Sub Department Name';
        this.dynamiccols();
      }
    );
  }

    customSort(event: SortEvent) {
      console.log(event, "sort event");
      event.data.sort((data1, data2) => {
        let value1 = data1[event.field];
        let value2 = data2[event.field];
        let result = 0;
  
        // Handle null values
        if (value1 == null && value2 == null) return 0; // Both are null
        if (value1 == null) return event.order === 1 ? 1 : -1; // value1 is null
        if (value2 == null) return event.order === 1 ? -1 : 1; // value2 is null
  
        // Determine result based on field type
        if (typeof value1 === 'string' && typeof value2 === 'string') {
          if (event.field === 'createdon') {
            // Parse date strings into Date objects
            const date1 = new Date(value1.split('-').reverse().join(',')); // Convert "DD-MMM-YYYY" to "YYYY,MMM,DD"
            const date2 = new Date(value2.split('-').reverse().join(','));
            result = date1.getTime() - date2.getTime(); // Compare timestamps
          } else {
            // Handle departmentname and other strings
            if (event.field === 'subdepartmentname' || event.field === 'departmentname') {
              result = value1.trim().toLowerCase().localeCompare(value2.trim().toLowerCase());
            } else {
              result = value1.localeCompare(value2);
            }
          }
        } 
        else if (typeof value1 === 'number' && typeof value2 === 'number') {
          // Numeric comparison
          result = value1 - value2;
        } else {
          // Fallback for mixed types or unexpected cases
          result = value1.toString().localeCompare(value2.toString());
        }
  
        return event.order === 1 ? result : -result;  // Adjust for ascending/descending order
      });
    }

  show(title, data) {
    let details = {}
    if (title === 'Modify Subdepartment') {
      this.subdepartmentservice.getSubdepartmentDataView_byId(data.subdepartmentid).subscribe(res => {
        details = res;
        this.ref = this.dialogService.open(SubdepartmentmodalComponent, {
        header: "Modify "+this.subdeptLabelName,
          width: '50vw',
          height: 'auto',
          data: { title: title, datas: details,subdeptlabel:this.subdeptLabelName},
          contentStyle: {},
          baseZIndex: 10000,
          maximizable: true,
        });
        this.ref.onClose.subscribe(() => {
          this.getsubdepartmentList();
        });
      })
    } else {
      details = {}
      this.ref = this.dialogService.open(SubdepartmentmodalComponent, {
        header: "Add "+this.subdeptLabelName,
        width: '50vw',
        height: 'auto',
        data: { title: title, datas: details,subdeptlabel:this.subdeptLabelName},
        contentStyle: { overflow: '' },
        baseZIndex: 10000,
        maximizable: true,
      });
      this.ref.onClose.subscribe(() => {
        this.getsubdepartmentList();
      });
    }
  }

  subdepartmentDataExcel() {
    this.spinner.show();
    this.subdepartmentservice.subdepartmentDataExcel().subscribe((response: Blob) => {
      const blob = new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = this.subdeptLabelName+'_Master_Data.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.exceldownloadModal = false;
       this.spinner.hide();
      Swal.fire('File downloaded successfully!', '', 'success');
    }, error => {
       this.spinner.hide();
      Swal.fire('Something went wrong', '', 'error');
    });
  }

  handlePageChange(event: any) {
    this.rowsize = event.rows;
    this.currentPageIndex = event.first;
  }

}



